<script lang="ts">
  let { height = '18rem', label = 'Caricamento' }: { height?: string; label?: string } = $props();
</script>

<div class="skeleton" style:min-height={height} aria-label={label} aria-busy="true">
  <span class="sr-only">{label}</span>
</div>
